export default "<p class=\"alert alert-info text-center\">{{ this.getWinningTeam() }}</p>\n"